import { render, staticRenderFns } from "./SurveyQualificationSinglePunch.vue?vue&type=template&id=35ebf602&scoped=true&"
import script from "./SurveyQualificationSinglePunch.vue?vue&type=script&lang=js&"
export * from "./SurveyQualificationSinglePunch.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQualificationSinglePunch.vue?vue&type=style&index=0&id=35ebf602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ebf602",
  null
  
)

export default component.exports